'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const modalDialogBody = "_modal-dialog-body_snegq_1";
const modalDialogBodyInner = "_modal-dialog-body-inner_snegq_36";
const styles = {
	modalDialogBody: modalDialogBody,
	modalDialogBodyInner: modalDialogBodyInner
};

const ModalDialogBody = ({ children, textAlign = "start" }) => {
  return React__default.default.createElement(
    "div",
    { className: styles.modalDialogBody, "data-text-align": textAlign, "data-zds": true },
    React__default.default.createElement("div", { className: styles.modalDialogBodyInner, "data-zds": true }, children)
  );
};

exports.ModalDialogBody = ModalDialogBody;
//# sourceMappingURL=Body.cjs.js.map
